import { TRANSLATION_KEYS } from "constants/TranslationConstant";

export function configureLocations({ data, error, isLoading }) {
  if (data === undefined || error || isLoading) {
    return [];
  }
  return data.data.map(({ latitude, longitude, name }) => ({
    markerLocation: name,
    center: [latitude, longitude],
    geoLocation: [latitude, longitude],
  }));
}

export function sortGovernorates(list, dir) {
  if (!Array.isArray(list)) return [];
  return [...list].sort((a, b) => {
    if (dir === "rtl") {
      return a.name < b.name ? -1 : 1;
    }
    if (
      a.governorateTranslations?.length > 0 ||
      b.governorateTranslations?.length > 0
    ) {
      return a.governorateTranslations[0]?.name <
        b.governorateTranslations[0]?.name
        ? -1
        : 1;
    }
    return a.name < b.name ? -1 : 1;
  });
}

export const EMPTY_ADDITIONAL_OFFICE = {
  officeName: "",
  mail: "",
  phoneNumber: "",
  elementTranslations: [],
};

export function parseAdditionalOffice(additionalData, itemKey) {
  if (!additionalData?.data) {
    return EMPTY_ADDITIONAL_OFFICE;
  }

  const additionalObj = additionalData.data.find(({ key }) => key === itemKey);
  if (!additionalObj) {
    return EMPTY_ADDITIONAL_OFFICE;
  }

  try {
    const { officeName, mail, phoneNumber } =
      JSON.parse(additionalObj.value) || {};
    return {
      officeName: officeName || "",
      mail: mail || "",
      phoneNumber: phoneNumber || "",
      elementTranslations: additionalObj[TRANSLATION_KEYS.ELEMENTS] || [],
    };
  } catch {
    return EMPTY_ADDITIONAL_OFFICE;
  }
}
